<template>
  <div class="chat-right">
    <span class="content">{{ content }}</span>
  </div>
</template>

<script>
  export default {
    name: 'LiuXuanTestChatRight',
    props: {
      content: {
        type: String,
        required: true,
      },
    },
    created() {
      document.getElementById('page-end').scrollIntoView();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .chat-right {
    width: 100%;
    padding-right: @size-base;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
  }

  .content {
    min-width: 150px;
    min-height: 70px;
    box-sizing: border-box;
    right: @size-base;
    padding: 0 @size-base;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: @font-size-base;
    color: @color-white;
    background: #36aba8;
    box-shadow: 0 2px 15px 0 rgba(71,159,157,0.17);
    border-radius: 32px 20px 5px 32px;
  }

</style>
